'use-client';
import WFacebookComment from '../../WFacebookComment';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';
import styles from '../../styles/WFacebookComment.scss';

export default WithConsentPolicy(WFacebookComment, {
  rootClassName: styles.root,
  componentConsentPolicy: { advertising: true },
});
